import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { TRANSLATION_DOMAINS } from '../../../consts';
import { FlagIcon } from '../../../icons/components';
import { useStores } from '../../../recipes';

import './styles.scss';

export const OwnedAlertsPanel = observer(() => {
	const { t } = useTranslation();

	const {
		alertsStore: { ownedAlertsInfo }
	} = useStores();

	return (
		<div className="exceptions-owned-alerts">
			<FlagIcon className="exceptions-owned-alerts-icon" />
			{ownedAlertsInfo.numberOfAlerts ? (
				<span className="exceptions-owned-alerts-text">{`${t(
					`${TRANSLATION_DOMAINS.EXCEPTIONS_LIST}.NUMBERS_OF_OWNED_ALERTS`,
					{ numberOfAlerts: ownedAlertsInfo.numberOfAlerts, numberOfOrders: ownedAlertsInfo.numberOfOrders }
				)}`}</span>
			) : (
				t(`${TRANSLATION_DOMAINS.EXCEPTIONS_LIST}.NO_OWNED_ALERTS`)
			)}
		</div>
	);
});
